import { render, staticRenderFns } from "./UserBasic.vue?vue&type=template&id=c3b04c22&scoped=true&"
import script from "./UserBasic.vue?vue&type=script&lang=ts&"
export * from "./UserBasic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b04c22",
  null
  
)

export default component.exports